import { render, staticRenderFns } from "./vehicle-card.vue?vue&type=template&id=0d79f6b5"
import script from "./vehicle-card.vue?vue&type=script&lang=ts"
export * from "./vehicle-card.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./vehicle-card.vue?vue&type=style&index=0&id=0d79f6b5&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports